export enum EnumAction {
  AltaCompraVenta = 1
}
